<div class="sub-menu-container level-1">
  <ul *ngIf="subMenuItemList && subMenuItemList.length > 0" class="sub-menu-list">
    <ng-template ngFor let-subMenuItem [ngForOf]="subMenuItemList" let-i="index">
      <li *ngIf="subMenuItem.visible" class="sub-menu-item" [ngClass]="{ 'menu-item-bg-color': i === selectedIndex }" [attr.data-test-id]="'menu-sub-items-' + subMenuItem.routerLink">
        <a [attr.aria-current]="selectedIndex ? 'page' : null" (click)="setRouterObject(subMenuItem); selectedIndex = i" [routerLink]="'/' + subMenuItem.routerLink">
          <mat-icon *ngIf="subMenuItem.svgIcon !== false" [svgIcon]="subMenuItem.icon" aria-hidden="true"></mat-icon>
          <mat-icon *ngIf="subMenuItem.svgIcon === false" aria-hidden="true">
            <span class="material-icons-outlined">{{ subMenuItem.icon }}</span>
          </mat-icon>
          <span class="w-full inline-block">{{ subMenuItem.text }}</span>
          <span *ngIf="subMenuItem.key === 'assets-basket' && assetBasketService.assetIdsFromMyBasket.length" class="inline-block badge" i18n-matTooltip matTooltip="Items added to the basket">
            {{ assetBasketService.assetIdsFromMyBasket.length }}
          </span>
        </a>
      </li>
    </ng-template>
  </ul>
</div>
